import {createContext} from "react";

export const SidebarContext = createContext({
	"sidebarOpen": true,
	"setSidebarOpen": ()=>null,
})